import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getRegs, insert, oikosGet, update } from '../../../utils/fc'
import { notifyError, notifySuccess } from '../../../utils/notify'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import { ListaTarefas } from '../Atividades'
import RegistrarPonto from '../../HumanResources/RegistrarPonto'
import './GestaoAtividades.css'
import '../Atividades/Atividades.css'

const STATUS_NAO_INICIADO = 1
const STATUS_EM_ANDAMENTO = 2
const STATUS_CONCLUIDO = 3
const LOCAIS = ['Homeoffice', 'Campo', 'Ecossis', 'Cliente']
const UNIDADES_ORDEM = [6, 1, 2]
const NOME_UNIDADE = {
  6: ['minuto', 'minutos'],
  1: ['hora', 'horas'],
  2: ['dia', 'dias'],
}

function listaDe(resposta) {
  const corpo = resposta && resposta.data
  return Array.isArray(corpo) ? corpo : []
}

async function listar(table, data = {}) {
  const resposta = await oikosGet({ action: 'get', table, data })
  return listaDe(resposta)
}

function mesmoId(a, b) {
  return String(a) === String(b)
}

function ordenarNaturezas(lista) {
  return [...lista].sort((a, b) => String(a.setorAtiv_nome).localeCompare(String(b.setorAtiv_nome), 'pt-BR'))
}

function cargoIdDaPessoa(pessoas, pfId) {
  if (pfId == null || pfId === '') return null
  const pessoa = pessoas.find(item => mesmoId(item.pf_id, pfId))
  if (!pessoa || pessoa.cargo_id == null || pessoa.cargo_id === '') return null
  const cargoId = Number(pessoa.cargo_id)
  return Number.isNaN(cargoId) ? null : cargoId
}

function naturezasDoCargo(setorAtivLista, vinculos, cargoId) {
  if (cargoId == null) return []
  const ids = new Set(
    vinculos
      .filter(item => mesmoId(item.cargo_id, cargoId) && item.setorAtiv_id != null && item.setorAtiv_id !== '')
      .map(item => String(item.setorAtiv_id)),
  )
  return ordenarNaturezas(setorAtivLista.filter(item => ids.has(String(item.setorAtiv_id))))
}

function diaIso(valor) {
  if (!valor) return ''
  const texto = String(valor).slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(texto) ? texto : ''
}

function horaIso(valor) {
  if (valor == null || valor === '') return ''
  const achado = String(valor).trim().match(/^(\d{1,2}):(\d{2})/)
  if (!achado) return ''
  const hora = Number(achado[1])
  const minuto = Number(achado[2])
  if (hora > 23 || minuto > 59) return ''
  return `${String(hora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`
}

function tempoPreenchido(texto) {
  return /^(\d{2}):([0-5]\d)$/.test(String(texto || '')) && texto !== '00:00'
}

function minutosDe(valor) {
  if (valor == null || valor === '') return 0
  const partes = String(valor).trim().match(/^(\d+):(\d{2})(?::(\d{2}))?/)
  if (!partes) return 0
  return (Number(partes[1]) * 60) + Number(partes[2])
}

function tempoSql(minutos) {
  const horas = Math.floor(minutos / 60)
  const resto = minutos % 60
  return `${String(horas).padStart(2, '0')}:${String(resto).padStart(2, '0')}:00`
}

function hojeIso() {
  const d = new Date()
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const dia = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mes}-${dia}`
}

function ontemIso() {
  const data = new Date()
  data.setDate(data.getDate() - 1)
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const dia = String(data.getDate()).padStart(2, '0')
  return `${data.getFullYear()}-${mes}-${dia}`
}

function dataPrevistaConclusao(item) {
  if (!item) return ''
  return somarDias(item.atividade_dtIniPlanejada, item.atividade_prazoDiasExecucao)
    || diaIso(item.atividade_dtFimPlanejada)
}

function formatarIso(valor) {
  const iso = diaIso(valor)
  if (!iso) return ''
  const [ano, mes, dia] = iso.split('-')
  return `${dia}/${mes}/${ano}`
}

function somarDias(inicio, dias) {
  const base = diaIso(inicio)
  if (!base || dias === '' || dias == null) return null
  const n = Number(dias)
  if (Number.isNaN(n) || n < 0) return null
  const [ano, mes, dia] = base.split('-').map(Number)
  const data = new Date(ano, mes - 1, dia)
  data.setDate(data.getDate() + n)
  while (data.getDay() === 0 || data.getDay() === 6) {
    data.setDate(data.getDate() + 1)
  }
  const mm = String(data.getMonth() + 1).padStart(2, '0')
  const dd = String(data.getDate()).padStart(2, '0')
  return `${data.getFullYear()}-${mm}-${dd}`
}

function iconeMiv(slug) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/erp-design-miv/icons/ui-oval/${slug}.svg`
}

function faixasQuadro(colunas, recolhidas) {
  const x = 'var(--gestao-col-x)'
  const flex = 'minmax(0, 1fr)'
  return colunas.map(coluna => (
    coluna.podeRecolher && recolhidas[String(coluna.id)] ? x : flex
  )).join(' ')
}

function BotaoIcone({ slug, label, perigo, onClick }) {
  return (
    <button
      type="button"
      className={`gestao-btn-icone${perigo ? ' is-perigo' : ''}`}
      aria-label={label}
      title={label}
      onClick={event => {
        event.stopPropagation()
        onClick(event)
      }}
    >
      <img src={iconeMiv(slug)} alt="" width="16" height="16" />
    </button>
  )
}

function rotuloMes(chave) {
  const [ano, mes] = chave.split('-').map(Number)
  const nome = new Date(ano, mes - 1, 1).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
  return nome.charAt(0).toUpperCase() + nome.slice(1)
}

function rotuloQuantidade(unidadeId, quantidade) {
  const par = NOME_UNIDADE[Number(unidadeId)]
  if (!par || quantidade === '' || quantidade == null) return ''
  const n = Number(quantidade)
  return `${n} ${n === 1 ? par[0] : par[1]}`
}

function normalizar(texto) {
  return String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

function situacaoIdPorNome(lista, nome) {
  const alvo = normalizar(nome)
  const achado = (lista || []).find(item => (
    Number(item.projSituacao_ativo) !== 0 && normalizar(item.projSituacao_desc) === alvo
  ))
  const id = achado ? Number(achado.projSituacao_id) : NaN
  return Number.isInteger(id) && id > 0 ? id : null
}

function filtroAtividadeKanban(user, veTudo, situacaoId) {
  const id = Number(situacaoId)
  const semPropOrcItem = 'SELECT a.atividade_id FROM atividade a WHERE NOT EXISTS (SELECT 1 FROM relacaoAtividadePropOrcItem r0 WHERE r0.atividade_id = a.atividade_id AND r0.relacaoAtividadePropOrcItem_ativo = 1)'
  const comProjetoAndamento = Number.isInteger(id) && id > 0
    ? `SELECT r.atividade_id FROM relacaoAtividadePropOrcItem r INNER JOIN propOrcItem i ON i.propOrcItem_id = r.propOrcItem_id AND IFNULL(i.propOrcItem_ativo, 1) = 1 INNER JOIN contrato c ON c.prop_id = i.prop_id AND IFNULL(c.contrato_ativo, 1) = 1 INNER JOIN proj p ON p.contrato_id = c.contrato_id AND IFNULL(p.proj_ativo, 1) = 1 WHERE r.relacaoAtividadePropOrcItem_ativo = 1 AND p.projSituacao_id = ${id}`
    : null
  const uniao = comProjetoAndamento ? `${comProjetoAndamento} UNION ${semPropOrcItem}` : semPropOrcItem
  const filtro = {
    atividade_id: `!IN!(${uniao})`,
  }
  if (!veTudo) filtro.pf_id = Number(user.pf_id)
  return filtro
}

function nomePessoa(pessoa) {
  if (!pessoa) return ''
  if (pessoa.pf_nomeExibicao) return pessoa.pf_nomeExibicao
  return [pessoa.pf_nome, pessoa.pf_sobrenome].filter(Boolean).join(' ')
}

function equipeNaData(linha, hoje) {
  const ini = diaIso(linha.projEquipe_ini)
  const fim = diaIso(linha.projEquipe_fim)
  if (ini && ini > hoje) return false
  if (fim && fim < hoje) return false
  return true
}

function numeroOuNull(valor) {
  if (valor === '' || valor == null) return null
  const n = Number(valor)
  return Number.isNaN(n) ? null : n
}

const ALFABETO_ORDEM = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

function chaveEntre(antes, depois) {
  const inicio = antes ? String(antes) : ''
  const fim = depois ? String(depois) : ''
  if (fim && inicio >= fim) return null
  let prefixo = ''
  for (let i = 0; i < 48; i += 1) {
    const ca = i < inicio.length ? ALFABETO_ORDEM.indexOf(inicio[i]) : 0
    const cb = fim && i < fim.length ? ALFABETO_ORDEM.indexOf(fim[i]) : ALFABETO_ORDEM.length
    if (ca < 0 || cb < 0) return null
    if (cb - ca > 1) {
      return prefixo + ALFABETO_ORDEM[ca + Math.floor((cb - ca) / 2)]
    }
    prefixo += ALFABETO_ORDEM[ca]
  }
  return null
}

function ordenarPorChave(lista) {
  return [...lista].sort((a, b) => {
    const oa = a.atividade_ord ? String(a.atividade_ord) : ''
    const ob = b.atividade_ord ? String(b.atividade_ord) : ''
    if (oa && ob && oa !== ob) return oa < ob ? -1 : 1
    if (oa !== ob) return oa ? -1 : 1
    return Number(a.atividade_id) - Number(b.atividade_id)
  })
}

function chavesEmFalta(lista) {
  const porStatus = new Map()
  lista.forEach(item => {
    const status = String(item.atividadeStatus_id)
    if (!porStatus.has(status)) porStatus.set(status, [])
    porStatus.get(status).push(item)
  })
  const atribuicoes = []
  porStatus.forEach(grupo => {
    const ordenado = ordenarPorChave(grupo)
    let anterior = null
    ordenado.forEach(item => {
      if (item.atividade_ord) {
        anterior = String(item.atividade_ord)
        return
      }
      const chave = chaveEntre(anterior, null)
      if (!chave) return
      anterior = chave
      atribuicoes.push({ id: item.atividade_id, chave })
    })
  })
  return atribuicoes
}

function comOrdem(lista) {
  const atribuicoes = chavesEmFalta(lista)
  if (!atribuicoes.length) return { lista, atribuicoes }
  const porId = new Map(atribuicoes.map(item => [String(item.id), item.chave]))
  return {
    atribuicoes,
    lista: lista.map(item => (
      porId.has(String(item.atividade_id))
        ? { ...item, atividade_ord: porId.get(String(item.atividade_id)) }
        : item
    )),
  }
}

function textoOuNull(valor) {
  const texto = valor == null ? '' : String(valor).trim()
  return texto === '' ? null : texto
}

function formDeItem(item) {
  return {
    atividade_id: item.atividade_id,
    atividade_nome: item.atividade_nome || '',
    proj_id: item.proj_id ? String(item.proj_id) : '',
    prod_id: item.prod_id ? String(item.prod_id) : '',
    pf_id: item.pf_id ? String(item.pf_id) : '',
    unidade_id: item.unidade_id ? String(item.unidade_id) : '',
    atividade_unidadeQtd: item.atividade_unidadeQtd ?? '',
    atividade_dtIniPlanejada: diaIso(item.atividade_dtIniPlanejada),
    atividade_dtFimPlanejada: diaIso(item.atividade_dtFimPlanejada),
    atividade_prazoDiasExecucao: item.atividade_prazoDiasExecucao ?? '',
    atividade_tempoEstimado: horaIso(item.atividade_tempoEstimado),
    atividade_local: item.atividade_local || '',
    atividade_coment: item.atividade_coment || '',
    atividade_dtIniReal: diaIso(item.atividade_dtIniReal),
    atividade_dtFimReal: diaIso(item.atividade_dtFimReal),
    setorAtiv_id: item.setorAtiv_id ? String(item.setorAtiv_id) : '',
    atividadeStatus_id: item.atividadeStatus_id ? String(item.atividadeStatus_id) : '',
  }
}

function Cartao({
  item,
  produto,
  unidade,
  tarefas,
  aberta,
  compacto,
  tresLinhas,
  marca,
  projetosCard,
  produtosCard,
  pessoasCard,
  onAbrir,
  onGravar,
  onMarcarHoje,
  onExcluirAtividade,
  onAdicionarTarefa,
  onConcluirTarefa,
  onRenomearTarefa,
  onExcluirTarefa,
  onSobre,
  onSoltar,
  onFimArraste,
}) {
  const arrastou = useRef(false)
  const [painel, setPainel] = useState(null)
  const projId = item.proj_id || (produto ? produto.proj_id : '')
  const qtdTarefas = (tarefas || []).length
  const conclusao = somarDias(item.atividade_dtIniPlanejada, item.atividade_prazoDiasExecucao)
    || diaIso(item.atividade_dtFimPlanejada)

  function iniciarArraste(event) {
    arrastou.current = true
    const transferencia = event.dataTransfer
    transferencia.setData('text/plain', String(item.atividade_id))
    transferencia.effectAllowed = 'move'
  }

  function abrirPelaAlca() {
    if (arrastou.current) {
      arrastou.current = false
      return
    }
    onAbrir(item)
  }

  function posicaoPeloCursor(event) {
    const rect = event.currentTarget.getBoundingClientRect()
    return event.clientY > rect.top + rect.height / 2 ? 'depois' : 'antes'
  }

  function alternarPainel(proximo) {
    setPainel(atual => (atual === proximo ? null : proximo))
  }

  const acoes = !compacto && (
    <div className={`gestao-card-acoes${tresLinhas ? ' gestao-card-l3' : ''}`}>
      <label className="gestao-hoje" htmlFor={`gestao-hoje-${item.atividade_id}`}>
        <input
          id={`gestao-hoje-${item.atividade_id}`}
          type="checkbox"
          checked={diaIso(item.atividade_dtAtivHj) === hojeIso()}
          onChange={event => onMarcarHoje(item, event.target.checked)}
        />
        Tarefa de hoje
      </label>
      <button
        type="button"
        className="gestao-aba"
        aria-expanded={painel === 'tarefas'}
        onClick={() => alternarPainel('tarefas')}
      >
        {qtdTarefas ? `Tarefas (${qtdTarefas})` : 'Tarefas'}
      </button>
      <button
        type="button"
        className="gestao-aba"
        aria-expanded={painel === 'detalhes'}
        onClick={() => alternarPainel('detalhes')}
      >
        Ver detalhes
      </button>
    </div>
  )

  return (
    <article
      className={`gestao-card${compacto ? ' is-compacto' : ''}${!compacto && tresLinhas ? ' is-tres-linhas' : ''}${aberta ? ' is-aberta' : ''}${marca === 'antes' ? ' is-antes' : ''}${marca === 'depois' ? ' is-depois' : ''}`}
      onDragOver={event => {
        event.preventDefault()
        event.stopPropagation()
        onSobre(posicaoPeloCursor(event))
      }}
      onDrop={event => {
        event.preventDefault()
        event.stopPropagation()
        onSoltar(event, posicaoPeloCursor(event))
      }}
    >
      <div className="gestao-card-l1">
        <button
          type="button"
          className="gestao-alca"
          draggable
          aria-label="Arrastar para mudar a ordem ou o status."
          onDragStart={iniciarArraste}
          onDragEnd={() => {
            setTimeout(() => { arrastou.current = false }, 0)
            onFimArraste()
          }}
          onClick={abrirPelaAlca}
        >
          ⋮⋮
        </button>
        <input
          className="ativ-nome"
          defaultValue={item.atividade_nome || ''}
          key={`nome-${item.atividade_id}-${item.atividade_nome || ''}`}
          placeholder="Nome da atividade"
          onClick={event => event.stopPropagation()}
          onBlur={event => {
            const texto = event.target.value
            if (texto === (item.atividade_nome || '')) return
            onGravar(item, { atividade_nome: texto })
          }}
        />
        {!compacto && (
          <p className="gestao-card-conclusao">
            <span>Data prevista para conclusão</span>
            {conclusao ? formatarIso(conclusao) : '—'}
          </p>
        )}
        {!compacto && (
          <>
            <BotaoIcone slug="pencil-01" label="Editar" onClick={() => onAbrir(item)} />
            <BotaoIcone slug="trash-01" label="Excluir" perigo onClick={() => onExcluirAtividade(item)} />
          </>
        )}
        {compacto && (
          <>
            <label className="gestao-hoje" htmlFor={`gestao-hoje-${item.atividade_id}`}>
              <input
                id={`gestao-hoje-${item.atividade_id}`}
                type="checkbox"
                checked={diaIso(item.atividade_dtAtivHj) === hojeIso()}
                onChange={event => onMarcarHoje(item, event.target.checked)}
              />
              <span className="gestao-hoje-rotulo">Hoje</span>
            </label>
            <BotaoIcone slug="pencil-01" label="Editar" onClick={() => onAbrir(item)} />
            <BotaoIcone slug="trash-01" label="Excluir" perigo onClick={() => onExcluirAtividade(item)} />
          </>
        )}
      </div>
      {!compacto && (
        <div className="gestao-card-l2">
          <label className="ativ-campo" htmlFor={`gestao-ini-${item.atividade_id}`}>
            Início previsto
            <input
              id={`gestao-ini-${item.atividade_id}`}
              type="date"
              value={diaIso(item.atividade_dtIniPlanejada)}
              onClick={event => event.stopPropagation()}
              onChange={event => onGravar(item, { atividade_dtIniPlanejada: event.target.value || null })}
            />
          </label>
          <label className="ativ-campo" htmlFor={`gestao-dias-${item.atividade_id}`}>
            Dias p/ execução
            <input
              id={`gestao-dias-${item.atividade_id}`}
              type="number"
              min="0"
              step="1"
              defaultValue={item.atividade_prazoDiasExecucao ?? ''}
              key={`dias-${item.atividade_id}-${item.atividade_prazoDiasExecucao ?? ''}`}
              onClick={event => event.stopPropagation()}
              onBlur={event => {
                const valor = event.target.value
                const n = valor === '' ? null : parseInt(valor, 10)
                const atual = item.atividade_prazoDiasExecucao === '' || item.atividade_prazoDiasExecucao == null
                  ? null
                  : Number(item.atividade_prazoDiasExecucao)
                if (n === atual) return
                if (n != null && (Number.isNaN(n) || n < 0)) return
                onGravar(item, { atividade_prazoDiasExecucao: n })
              }}
            />
          </label>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="ativ-campo gestao-campo-tempo" htmlFor={`gestao-tempo-${item.atividade_id}`}>
            Tempo previsto
            <MaskedInput
              id={`gestao-tempo-${item.atividade_id}`}
              mask="00:00"
              lazy={false}
              placeholder="HH:mm"
              value={horaIso(item.atividade_tempoEstimado)}
              onClick={event => event.stopPropagation()}
              onAccept={valor => {
                const texto = String(valor || '')
                if (texto && texto.length < 5) return
                const hora = horaIso(texto)
                if (hora === horaIso(item.atividade_tempoEstimado)) return
                onGravar(item, { atividade_tempoEstimado: hora || null })
              }}
            />
          </label>
          {!tresLinhas && acoes}
        </div>
      )}
      {tresLinhas && acoes}
      {!compacto && painel === 'tarefas' && (
        <ListaTarefas
          ocultarTitulo
          tarefas={tarefas}
          onAdicionar={nome => onAdicionarTarefa(item.atividade_id, nome)}
          onConcluir={onConcluirTarefa}
          onRenomear={onRenomearTarefa}
          onExcluir={onExcluirTarefa}
        />
      )}
      {!compacto && painel === 'detalhes' && (
        <div className="gestao-card-detalhes">
          <label className="ativ-campo" htmlFor={`gestao-proj-${item.atividade_id}`}>
            Projeto
            <select
              id={`gestao-proj-${item.atividade_id}`}
              value={projId || ''}
              onChange={event => onGravar(item, { proj_id: event.target.value || null })}
            >
              <option value="">Sem projeto</option>
              {projetosCard.map(opcao => (
                <option key={opcao.proj_id} value={opcao.proj_id}>{opcao.proj_nome}</option>
              ))}
            </select>
          </label>
          <label className="ativ-campo" htmlFor={`gestao-prod-${item.atividade_id}`}>
            Produto
            <select
              id={`gestao-prod-${item.atividade_id}`}
              value={item.prod_id || ''}
              onChange={event => onGravar(item, { prod_id: event.target.value || null })}
            >
              <option value="">Sem produto</option>
              {produtosCard.map(opcao => (
                <option key={opcao.prod_id} value={opcao.prod_id}>{opcao.prod_desc}</option>
              ))}
            </select>
          </label>
          <label className="ativ-campo" htmlFor={`gestao-pf-${item.atividade_id}`}>
            Responsável
            <select
              id={`gestao-pf-${item.atividade_id}`}
              value={item.pf_id || ''}
              onChange={event => onGravar(item, { pf_id: event.target.value || null })}
            >
              <option value="">Sem responsável</option>
              {pessoasCard.map(opcao => (
                <option key={opcao.pf_id} value={opcao.pf_id}>{nomePessoa(opcao)}</option>
              ))}
            </select>
          </label>
          {unidade && (
            <p className="gestao-card-dado">
              <span>Quantidade</span>
              {unidade}
            </p>
          )}
          {item.atividade_local && (
            <p className="gestao-card-dado">
              <span>Local</span>
              {item.atividade_local}
            </p>
          )}
        </div>
      )}
    </article>
  )
}

export default function GestaoAtividades() {
  const user = useSelector(state => state.auth.user)
  const veTudo = Number(user && user.perm_id) === 1
  const semPermissao = !user || !user.pf_id

  const [carregando, setCarregando] = useState(!semPermissao)
  const [erro, setErro] = useState('')
  const [atividades, setAtividades] = useState([])
  const [todos, setTodos] = useState([])
  const [pessoas, setPessoas] = useState([])
  const [projetos, setProjetos] = useState([])
  const [situacaoProjAndamentoId, setSituacaoProjAndamentoId] = useState(null)
  const [produtos, setProdutos] = useState([])
  const [equipe, setEquipe] = useState([])
  const [setorAtivLista, setSetorAtivLista] = useState([])
  const [cargoSetorAtiv, setCargoSetorAtiv] = useState([])
  const [statusLista, setStatusLista] = useState([])
  const [unidades, setUnidades] = useState([])
  const [busca, setBusca] = useState('')
  const [filtroPf, setFiltroPf] = useState('')
  const [filtroMes, setFiltroMes] = useState('')
  const [filtroTipo, setFiltroTipo] = useState('')
  const [filtroHoje, setFiltroHoje] = useState(false)
  const [filtroMinhas, setFiltroMinhas] = useState(false)
  const [modalPonto, setModalPonto] = useState(false)
  const [versao, setVersao] = useState(0)
  const [recolhidas, setRecolhidas] = useState({
    [STATUS_NAO_INICIADO]: true,
    [STATUS_CONCLUIDO]: true,
  })
  const [pergunta, setPergunta] = useState(null)
  const [concluirHoras, setConcluirHoras] = useState(null)
  const [sobre, setSobre] = useState('')
  const [form, setForm] = useState(null)
  const [base, setBase] = useState(null)
  const [salvando, setSalvando] = useState(false)
  const [criando, setCriando] = useState(false)
  const [marca, setMarca] = useState(null)
  const salvandoArraste = useRef(new Set())
  const chavesEmGravacao = useRef(new Map())

  const produtoPorId = useMemo(() => {
    const mapa = new Map()
    produtos.forEach(produto => mapa.set(String(produto.prod_id), produto))
    return mapa
  }, [produtos])

  const projetoPorId = useMemo(() => {
    const mapa = new Map()
    projetos.forEach(projeto => mapa.set(String(projeto.proj_id), projeto))
    return mapa
  }, [projetos])

  const colunas = useMemo(() => [...statusLista]
    .filter(item => (
      item
      && item.atividadeStatus_id != null
      && Number(item.atividadeStatus_ativo) === 1
      && Number(item.atividadeStatus_exibir) === 1
    ))
    .sort((a, b) => Number(a.atividadeStatus_id) - Number(b.atividadeStatus_id))
    .map(item => {
      const id = Number(item.atividadeStatus_id)
      return {
        id,
        nome: item.atividadeStatus_nome || `Status ${id}`,
        podeRecolher: id !== STATUS_EM_ANDAMENTO,
        podeCriar: id === STATUS_NAO_INICIADO,
      }
    }), [statusLista])

  const todasExpandidas = colunas.every(coluna => !coluna.podeRecolher || !recolhidas[String(coluna.id)])

  const idsQuadro = useMemo(
    () => new Set(colunas.map(coluna => coluna.id).filter(id => id != null).map(String)),
    [colunas],
  )

  function naEquipe(pfId, projId) {
    if (!pfId || !projId) return false
    return equipe.some(linha => mesmoId(linha.pf_id, pfId) && mesmoId(linha.proj_id, projId))
  }

  const meses = useMemo(() => {
    const chaves = new Set()
    atividades.forEach(item => {
      const inicio = diaIso(item.atividade_dtIniPlanejada)
      if (inicio) chaves.add(inicio.slice(0, 7))
    })
    return [...chaves].sort()
  }, [atividades])

  const pfFiltroNatureza = (!veTudo || filtroMinhas) ? (user && user.pf_id) : filtroPf
  const formPfId = form && form.pf_id
  const formNaturezaId = form && form.setorAtiv_id
  const naturezasFiltro = useMemo(
    () => naturezasDoCargo(setorAtivLista, cargoSetorAtiv, cargoIdDaPessoa(pessoas, pfFiltroNatureza)),
    [setorAtivLista, cargoSetorAtiv, pessoas, pfFiltroNatureza],
  )
  const naturezasForm = useMemo(
    () => naturezasDoCargo(setorAtivLista, cargoSetorAtiv, cargoIdDaPessoa(pessoas, formPfId)),
    [setorAtivLista, cargoSetorAtiv, pessoas, formPfId],
  )

  useEffect(() => {
    if (filtroTipo && !naturezasFiltro.some(item => mesmoId(item.setorAtiv_id, filtroTipo))) {
      setFiltroTipo('')
    }
  }, [filtroTipo, naturezasFiltro])

  useEffect(() => {
    if (!formNaturezaId) return undefined
    if (!naturezasForm.some(item => mesmoId(item.setorAtiv_id, formNaturezaId))) {
      setForm(atual => (atual ? { ...atual, setorAtiv_id: '' } : atual))
    }
    return undefined
  }, [formNaturezaId, naturezasForm])

  const visiveis = useMemo(() => atividades.filter(item => {
    const inicio = diaIso(item.atividade_dtIniPlanejada)
    const nomeOk = !busca.trim() || normalizar(item.atividade_nome).includes(normalizar(busca))
    const minhasOk = !filtroMinhas || mesmoId(item.pf_id, user && user.pf_id)
    const pessoaOk = !veTudo || filtroMinhas || !filtroPf || mesmoId(item.pf_id, filtroPf)
    if (filtroMes && inicio.slice(0, 7) !== filtroMes) return false
    if (filtroTipo && !mesmoId(item.setorAtiv_id, filtroTipo)) return false
    if (filtroHoje && diaIso(item.atividade_dtAtivHj) !== hojeIso()) return false
    return nomeOk && pessoaOk && minhasOk
  }), [atividades, busca, filtroPf, veTudo, filtroMes, filtroTipo, filtroHoje, filtroMinhas, user])

  const fora = visiveis.filter(item => !idsQuadro.has(String(item.atividadeStatus_id)))

  useEffect(() => {
    if (semPermissao) return undefined
    let vivo = true
    async function carregar() {
      try {
        const [proj, prod, pf, eq, situacoesProj, setoresAtiv, vinculosCargo, statusAtiv, unid, listaTodo] = await Promise.all([
          getRegs('proj', { proj_ativo: 1 }),
          getRegs('prod', { prod_ativo: 1 }),
          getRegs('pf'),
          getRegs('projEquipe', { projEquipe_ativo: 1 }),
          listar('projSituacao', { projSituacao_ativo: 1 }),
          listar('setorAtiv'),
          listar('cargoSetorAtiv'),
          listar('atividadeStatus', { atividadeStatus_ativo: 1, atividadeStatus_exibir: 1 }),
          listar('unidade'),
          getRegs('todo', { todo_tabRef: 'atividade' }),
        ])
        if (!vivo) return
        if (!Array.isArray(statusAtiv)) {
          throw new Error('carga')
        }
        const situacaoId = situacaoIdPorNome(situacoesProj, 'Em andamento')
        setSituacaoProjAndamentoId(situacaoId)
        const filtroAtividade = filtroAtividadeKanban(user, veTudo, situacaoId)
        const ativ = await getRegs('atividade', filtroAtividade)
        if (!vivo) return
        if (!Array.isArray(ativ)) {
          throw new Error('carga')
        }
        const hoje = hojeIso()
        setProjetos(proj || [])
        setProdutos(prod || [])
        setPessoas(pf || [])
        setEquipe((eq || []).filter(linha => equipeNaData(linha, hoje)))
        const ativas = ativ.filter(item => Number(item.atividade_ativo) !== 0)
        const preparadas = comOrdem(ativas)
        setAtividades(preparadas.lista)
        persistirChaves(preparadas.atribuicoes)
        setTodos(listaTodo || [])
        setSetorAtivLista(Array.isArray(setoresAtiv) ? setoresAtiv : [])
        setCargoSetorAtiv(Array.isArray(vinculosCargo) ? vinculosCargo : [])
        setStatusLista(statusAtiv)
        setUnidades(unid.filter(item => UNIDADES_ORDEM.includes(Number(item.unidade_id))))
      } catch (e) {
        if (!vivo) return
        setErro('Não foi possível carregar as atividades.')
        notifyError('Não foi possível carregar as atividades.')
      } finally {
        if (vivo) setCarregando(false)
      }
    }
    carregar()
    return () => { vivo = false }
  }, [semPermissao, veTudo, user, versao])

  function tarefasDe(atividadeId) {
    return todos.filter(tarefa => (
      tarefa.todo_tabRef === 'atividade' && mesmoId(tarefa.todo_tabId, atividadeId)
    ))
  }

  function pessoaDe(pfId) {
    return pessoas.find(pessoa => mesmoId(pessoa.pf_id, pfId))
  }

  async function persistirChaves(atribuicoes) {
    if (!atribuicoes.length) return
    atribuicoes.forEach(item => chavesEmGravacao.current.set(String(item.id), item.chave))
    let falhou = false
    for (let i = 0; i < atribuicoes.length; i += 1) {
      const item = atribuicoes[i]
      const id = String(item.id)
      if (chavesEmGravacao.current.get(id) === item.chave) {
        // eslint-disable-next-line no-await-in-loop
        const ok = await update('atividade', item.id, { atividade_ord: item.chave })
        if (!ok && chavesEmGravacao.current.get(id) === item.chave) falhou = true
      }
    }
    if (falhou) notifyError('Não foi possível guardar a ordem das atividades.')
  }

  function limparMarca() {
    setSobre('')
    setMarca(null)
  }

  function marcarCartao(item, posicao) {
    setMarca(atual => (
      atual && atual.id === String(item.atividade_id) && atual.posicao === posicao
        ? atual
        : { id: String(item.atividade_id), posicao }
    ))
  }

  function sujo() {
    if (!form || !base) return false
    return JSON.stringify(form) !== JSON.stringify(base)
  }

  function confirmarDescarte() {
    if (!sujo()) return true
    // eslint-disable-next-line no-alert
    return window.confirm('Há alterações não salvas. Deseja descartá-las?')
  }

  function abrir(item) {
    if (form && item && mesmoId(form.atividade_id, item.atividade_id)) return
    if (!confirmarDescarte()) return
    const proximo = formDeItem(item)
    if (!proximo.proj_id && proximo.prod_id) {
      const produto = produtoPorId.get(String(proximo.prod_id))
      if (produto && produto.proj_id) proximo.proj_id = String(produto.proj_id)
    }
    setForm(proximo)
    setBase(proximo)
  }

  async function criarNaColuna(statusId) {
    if (statusId == null || !mesmoId(statusId, STATUS_NAO_INICIADO) || criando) return
    setCriando(true)
    try {
      const daColuna = ordenarPorChave(atividades.filter(item => mesmoId(item.atividadeStatus_id, statusId)))
      const ultima = daColuna.length ? daColuna[daColuna.length - 1].atividade_ord : null
      const id = await insert('atividade', {
        atividadeStatus_id: Number(statusId),
        pf_id: Number(user.pf_id),
        atividade_ord: chaveEntre(ultima ? String(ultima) : null, null),
      })
      if (!id) {
        notifyError('Não foi possível criar a atividade.')
        return
      }
      await recarregar()
    } catch (e) {
      notifyError('Não foi possível criar a atividade.')
    } finally {
      setCriando(false)
    }
  }

  function fechar() {
    if (salvando) return
    if (!confirmarDescarte()) return
    setForm(null)
    setBase(null)
  }

  function escolherProjeto(projId) {
    setForm(prev => {
      const next = { ...prev, proj_id: projId }
      if (next.prod_id) {
        const produto = produtoPorId.get(String(next.prod_id))
        if (!produto || !mesmoId(produto.proj_id, projId)) next.prod_id = ''
      }
      if (veTudo && projId && next.pf_id && !naEquipe(next.pf_id, projId)) next.pf_id = ''
      return next
    })
  }

  function escolherProduto(prodId) {
    setForm(prev => {
      if (!prodId) return { ...prev, prod_id: '' }
      const produto = produtoPorId.get(String(prodId))
      const projId = produto ? String(produto.proj_id) : prev.proj_id
      const next = { ...prev, prod_id: prodId, proj_id: projId }
      if (veTudo && projId && next.pf_id && !naEquipe(next.pf_id, projId)) next.pf_id = ''
      return next
    })
  }

  function montarDados(origem) {
    const prodId = numeroOuNull(origem.prod_id)
    let projId = numeroOuNull(origem.proj_id)
    if (prodId) {
      const produto = produtoPorId.get(String(prodId))
      projId = produto ? Number(produto.proj_id) : projId
    }
    return {
      prodId,
      projId,
      dados: {
        atividade_nome: textoOuNull(origem.atividade_nome),
        proj_id: projId,
        prod_id: prodId,
        pf_id: numeroOuNull(origem.pf_id),
        unidade_id: numeroOuNull(origem.unidade_id),
        atividade_unidadeQtd: numeroOuNull(origem.atividade_unidadeQtd),
        atividade_dtIniPlanejada: origem.atividade_dtIniPlanejada || null,
        atividade_prazoDiasExecucao: numeroOuNull(origem.atividade_prazoDiasExecucao),
        atividade_dtFimPlanejada: somarDias(origem.atividade_dtIniPlanejada, origem.atividade_prazoDiasExecucao),
        atividade_tempoEstimado: horaIso(origem.atividade_tempoEstimado) || null,
        atividade_dtIniReal: origem.atividade_dtIniReal || null,
        atividade_dtFimReal: origem.atividade_dtFimReal || null,
        atividade_local: textoOuNull(origem.atividade_local),
        atividade_coment: textoOuNull(origem.atividade_coment),
        setorAtiv_id: numeroOuNull(origem.setorAtiv_id),
        atividadeStatus_id: numeroOuNull(origem.atividadeStatus_id),
      },
    }
  }

  function statusEhEmAndamento(statusId) {
    return mesmoId(statusId, STATUS_EM_ANDAMENTO)
  }

  function faltandoParaEmAndamento(origem) {
    const { dados } = montarDados(origem)
    const faltando = []
    if (dados.setorAtiv_id == null) faltando.push('Natureza da atividade')
    if (dados.pf_id == null) faltando.push('Responsável')
    if (!diaIso(dados.atividade_dtIniPlanejada)) faltando.push('Início previsto')
    if (dados.atividade_prazoDiasExecucao == null) faltando.push('Dias p/ execução')
    const tempo = horaIso(dados.atividade_tempoEstimado)
    if (!tempo || tempo === '00:00') faltando.push('Tempo previsto')
    return faltando
  }

  function recusarSeFaltaEmAndamento(origem, statusId) {
    if (!statusEhEmAndamento(statusId)) return false
    const faltando = faltandoParaEmAndamento(origem)
    if (!faltando.length) return false
    const coluna = colunas.find(item => mesmoId(item.id, STATUS_EM_ANDAMENTO))
    const rotulo = coluna ? coluna.nome : 'Em andamento'
    notifyError(`Para passar para ${rotulo}, preencha: ${faltando.join(', ')}.`)
    return true
  }

  function validar(origem) {
    const { prodId, projId, dados } = montarDados(origem)
    if (!dados.atividadeStatus_id) {
      notifyError('Escolha o status da atividade.')
      return null
    }
    if (!idsQuadro.has(String(dados.atividadeStatus_id))) {
      const nomes = colunas.map(coluna => coluna.nome).filter(Boolean)
      notifyError(nomes.length
        ? `O status precisa ser ${nomes.join(', ').replace(/, ([^,]*)$/, ' ou $1')}.`
        : 'O status da atividade não está no quadro.')
      return null
    }
    if (recusarSeFaltaEmAndamento(origem, dados.atividadeStatus_id)) return null
    if (prodId && !projId) {
      notifyError('Um produto precisa estar ligado a um projeto.')
      return null
    }
    if (dados.atividade_dtIniPlanejada && dados.atividade_dtFimPlanejada
      && dados.atividade_dtFimPlanejada < dados.atividade_dtIniPlanejada) {
      notifyError('A data prevista de fim precisa ser igual ou posterior à data prevista de início.')
      return null
    }
    if (dados.atividade_dtIniReal && dados.atividade_dtFimReal
      && dados.atividade_dtFimReal < dados.atividade_dtIniReal) {
      notifyError('A data de fim da realização precisa ser igual ou posterior à data de início da realização.')
      return null
    }
    if (dados.pf_id && projId && !naEquipe(dados.pf_id, projId)) {
      notifyError('O responsável precisa estar na equipe do projeto.')
      return null
    }
    if (!veTudo && !mesmoId(dados.pf_id, user.pf_id)) {
      notifyError('Você só pode alterar atividades atribuídas a você.')
      return null
    }
    return dados
  }

  async function gravarCampos(item, patch) {
    const junto = { ...formDeItem(item), ...patch }
    if (patch.prod_id) {
      const escolhido = produtoPorId.get(String(patch.prod_id))
      if (escolhido) junto.proj_id = String(escolhido.proj_id)
    }
    if (patch.proj_id && item.prod_id) {
      const atual = produtoPorId.get(String(item.prod_id))
      if (atual && !mesmoId(atual.proj_id, patch.proj_id)) junto.prod_id = ''
    }
    if (junto.proj_id && junto.pf_id && !naEquipe(junto.pf_id, junto.proj_id)) junto.pf_id = ''
    const dados = validar(junto)
    if (!dados) return
    if (item.atividade_ord) dados.atividade_ord = item.atividade_ord
    const id = await update('atividade', item.atividade_id, dados)
    if (!id) {
      notifyError('Não foi possível atualizar a atividade.')
      return
    }
    setAtividades(lista => lista.map(registro => (
      mesmoId(registro.atividade_id, item.atividade_id) ? { ...registro, ...dados } : registro
    )))
  }

  async function marcarHoje(item, marcado) {
    if (!veTudo && !mesmoId(item.pf_id, user.pf_id)) {
      notifyError('Você só pode alterar atividades atribuídas a você.')
      return
    }
    const data = marcado ? hojeIso() : null
    const id = await update('atividade', item.atividade_id, { atividade_dtAtivHj: data })
    if (!id) {
      notifyError('Não foi possível atualizar a tarefa de hoje.')
      return
    }
    setAtividades(lista => lista.map(registro => (
      mesmoId(registro.atividade_id, item.atividade_id)
        ? { ...registro, atividade_dtAtivHj: data }
        : registro
    )))
  }

  async function excluirAtividade(item) {
    if (!veTudo && !mesmoId(item.pf_id, user.pf_id)) {
      notifyError('Você só pode alterar atividades atribuídas a você.')
      return
    }
    const id = await update('atividade', item.atividade_id, { atividade_ativo: 0 })
    if (!id) {
      notifyError('Não foi possível excluir a atividade.')
      return
    }
    setAtividades(lista => lista.filter(registro => !mesmoId(registro.atividade_id, item.atividade_id)))
    if (form && mesmoId(form.atividade_id, item.atividade_id)) {
      setForm(null)
      setBase(null)
    }
  }

  async function recarregar() {
    const situacoesProj = await listar('projSituacao', { projSituacao_ativo: 1 })
    const situacaoId = situacaoIdPorNome(situacoesProj, 'Em andamento')
    setSituacaoProjAndamentoId(situacaoId)
    const filtroAtividade = filtroAtividadeKanban(user, veTudo, situacaoId)
    const [ativ, listaTodo] = await Promise.all([
      getRegs('atividade', filtroAtividade),
      getRegs('todo', { todo_tabRef: 'atividade' }),
    ])
    const ativas = (ativ || []).filter(item => Number(item.atividade_ativo) !== 0)
    const preparadas = comOrdem(ativas)
    setAtividades(preparadas.lista)
    persistirChaves(preparadas.atribuicoes)
    setTodos(listaTodo || [])
  }

  async function salvar(event) {
    event.preventDefault()
    const dados = validar(form)
    if (!dados) return
    const atual = atividades.find(item => mesmoId(item.atividade_id, form.atividade_id))
    if (atual && !mesmoId(atual.atividadeStatus_id, dados.atividadeStatus_id)) {
      const destino = ordenarPorChave(atividades.filter(item => (
        mesmoId(item.atividadeStatus_id, dados.atividadeStatus_id)
        && !mesmoId(item.atividade_id, atual.atividade_id)
      )))
      const ultima = destino.length ? destino[destino.length - 1].atividade_ord : null
      dados.atividade_ord = chaveEntre(ultima ? String(ultima) : null, null)
    } else if (atual && atual.atividade_ord) {
      dados.atividade_ord = atual.atividade_ord
    }
    setSalvando(true)
    try {
      const id = form.atividade_id
        ? await update('atividade', form.atividade_id, dados)
        : await insert('atividade', dados)
      if (!id) {
        notifyError('Não foi possível salvar a atividade.')
        return
      }
      await recarregar()
      setForm(null)
      setBase(null)
    } catch (e) {
      notifyError('Não foi possível salvar a atividade.')
    } finally {
      setSalvando(false)
    }
  }

  function setorIdDaAtividade(item) {
    if (!item || item.setorAtiv_id == null || item.setorAtiv_id === '') return null
    const natureza = setorAtivLista.find(opcao => mesmoId(opcao.setorAtiv_id, item.setorAtiv_id))
    if (!natureza || natureza.setor_id == null || natureza.setor_id === '') return null
    const setorId = Number(natureza.setor_id)
    return Number.isNaN(setorId) ? null : setorId
  }

  async function perguntarConclusao(item, statusId, alvo, posicao) {
    const lista = await getRegs('pontoAtiv', { atividade_id: Number(item.atividade_id) })
    if (!Array.isArray(lista)) {
      notifyError('Não foi possível verificar as horas da atividade.')
      return
    }
    const temHoras = lista.some(linha => Number(linha.pontoAtiv_ativo) !== 0)
    const prevista = dataPrevistaConclusao(item)
    const hoje = hojeIso()
    const retroativo = prevista !== hoje
    const destino = {
      item,
      statusId,
      alvo,
      posicao,
      tempo: '',
      gravando: false,
      retroativo,
      prevista,
      data: retroativo && prevista && prevista < hoje ? prevista : '',
      justificativa: '',
    }
    if (temHoras) {
      setPergunta({
        texto: 'Deseja registrar horas para essa atividade antes de concluí-la?',
        aoConfirmar: () => setConcluirHoras({ ...destino, obrigatorio: false }),
        aoNegar: () => mover(item.atividade_id, statusId, alvo, posicao, { pularConclusao: true }),
      })
      return
    }
    setConcluirHoras({ ...destino, obrigatorio: true })
  }

  async function confirmarHorasConclusao() {
    if (!concluirHoras || concluirHoras.gravando) return
    const { item, statusId, alvo, posicao, tempo, retroativo, data, justificativa } = concluirHoras
    if (!tempoPreenchido(tempo)) {
      notifyError('Informe o tempo realizado (HH:mm). 00:00 não conta.')
      return
    }
    const dataPonto = retroativo ? String(data || '').slice(0, 10) : hojeIso()
    const textoJustif = retroativo ? String(justificativa || '').trim() : ''
    if (retroativo) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dataPonto)) {
        notifyError('Informe a data do registro retroativo.')
        return
      }
      if (dataPonto >= hojeIso()) {
        notifyError('A data do registro retroativo precisa ser anterior a hoje.')
        return
      }
      if (!textoJustif) {
        notifyError('Informe a justificativa do registro retroativo.')
        return
      }
    }
    const setorId = setorIdDaAtividade(item)
    if (setorId == null) {
      notifyError('Só é possível lançar horas em atividades com Natureza da atividade.')
      return
    }
    const pfId = Number(user.pf_id)
    setConcluirHoras(atual => (atual ? { ...atual, gravando: true } : atual))
    const pontoId = await insert('ponto', {
      pf_id: pfId,
      ponto_justif: textoJustif,
      ponto_ativo: 1,
    })
    if (!pontoId) {
      notifyError('Não foi possível registrar as horas.')
      setConcluirHoras(atual => (atual ? { ...atual, gravando: false } : atual))
      return
    }
    const pontoAtivId = await insert('pontoAtiv', {
      ponto_id: Number(pontoId),
      pf_id: pfId,
      pontoAtiv_ativ: item.atividade_nome || '',
      pontoAtiv_desc: item.atividade_nome || '',
      pontoAtiv_tempo: `${tempo}:00`,
      pontoAtiv_aprov: 0,
      Lancado: 0,
      pontoAtiv_dt: dataPonto,
      pontoAtiv_justif: textoJustif,
      pontoAtiv_ativo: 1,
      pontoAtiv_usuarioMod: pfId,
      pontoAtiv_usuarioCria: pfId,
      atividade_id: Number(item.atividade_id),
      proj_tabela: 'setor',
      proj_id: setorId,
    })
    if (!pontoAtivId) {
      await update('ponto', pontoId, { ponto_ativo: 0 })
      notifyError('Não foi possível registrar as horas.')
      setConcluirHoras(atual => (atual ? { ...atual, gravando: false } : atual))
      return
    }
    const tempoReal = tempoSql(minutosDe(item.atividade_tempoReal) + minutosDe(tempo))
    const atualizado = await update('atividade', item.atividade_id, { atividade_tempoReal: tempoReal })
    if (!atualizado) {
      await update('ponto', pontoId, { ponto_ativo: 0 })
      await update('pontoAtiv', pontoAtivId, { pontoAtiv_ativo: 0 })
      notifyError('Não foi possível registrar as horas.')
      setConcluirHoras(atual => (atual ? { ...atual, gravando: false } : atual))
      return
    }
    setAtividades(lista => lista.map(registro => (
      mesmoId(registro.atividade_id, item.atividade_id)
        ? { ...registro, atividade_tempoReal: tempoReal }
        : registro
    )))
    setConcluirHoras(null)
    notifySuccess('Horas registradas.')
    await mover(item.atividade_id, statusId, alvo, posicao, { pularConclusao: true })
  }

  async function mover(id, statusId, alvo, posicao, opcoes = {}) {
    limparMarca()
    if (!id || statusId == null || salvandoArraste.current.has(String(id))) return
    const atual = atividades.find(item => mesmoId(item.atividade_id, id))
    if (!atual) return
    if (!veTudo && !mesmoId(atual.pf_id, user.pf_id)) return
    if (!opcoes.pularConclusao && !mesmoId(atual.atividadeStatus_id, statusId) && mesmoId(statusId, STATUS_CONCLUIDO)) {
      await perguntarConclusao(atual, statusId, alvo, posicao)
      return
    }
    const restantes = ordenarPorChave(visiveis.filter(item => (
      mesmoId(item.atividadeStatus_id, statusId) && !mesmoId(item.atividade_id, id)
    )))
    let indice = restantes.length
    if (alvo) {
      if (mesmoId(alvo.atividade_id, id)) return
      const achado = restantes.findIndex(item => mesmoId(item.atividade_id, alvo.atividade_id))
      if (achado < 0) return
      indice = posicao === 'depois' ? achado + 1 : achado
    }
    const anterior = indice > 0 ? restantes[indice - 1] : null
    const posterior = indice < restantes.length ? restantes[indice] : null
    if (mesmoId(atual.atividadeStatus_id, statusId)) {
      const colunaAtual = ordenarPorChave(visiveis.filter(item => mesmoId(item.atividadeStatus_id, statusId)))
      const idx = colunaAtual.findIndex(item => mesmoId(item.atividade_id, id))
      const antAtual = idx > 0 ? colunaAtual[idx - 1] : null
      const posAtual = idx >= 0 && idx < colunaAtual.length - 1 ? colunaAtual[idx + 1] : null
      const mesmoAnterior = mesmoId(antAtual && antAtual.atividade_id, anterior && anterior.atividade_id)
      const mesmoPosterior = mesmoId(posAtual && posAtual.atividade_id, posterior && posterior.atividade_id)
      if (mesmoAnterior && mesmoPosterior && (antAtual || posAtual || colunaAtual.length === 1)) return
    }
    const antesChave = anterior && anterior.atividade_ord ? String(anterior.atividade_ord) : null
    let depoisChave = posterior && posterior.atividade_ord ? String(posterior.atividade_ord) : null
    if (antesChave && depoisChave && antesChave >= depoisChave) depoisChave = null
    const chave = chaveEntre(antesChave, depoisChave)
    if (!chave) {
      notifyError('Não foi possível reordenar a atividade.')
      return
    }
    const statusAnterior = atual.atividadeStatus_id
    if (!mesmoId(statusAnterior, statusId) && recusarSeFaltaEmAndamento(atual, statusId)) return
    const ordemAnterior = atual.atividade_ord
    chavesEmGravacao.current.set(String(id), chave)
    salvandoArraste.current.add(String(id))
    setAtividades(lista => lista.map(item => (
      mesmoId(item.atividade_id, id)
        ? { ...item, atividadeStatus_id: statusId, atividade_ord: chave }
        : item
    )))
    if (form && mesmoId(form.atividade_id, id)) {
      setForm(valor => (valor ? { ...valor, atividadeStatus_id: String(statusId) } : valor))
      setBase(valor => (valor ? { ...valor, atividadeStatus_id: String(statusId) } : valor))
    }
    const payload = { atividade_ord: chave }
    if (!mesmoId(statusAnterior, statusId)) payload.atividadeStatus_id = Number(statusId)
    const gravado = await update('atividade', id, payload)
    salvandoArraste.current.delete(String(id))
    if (!gravado) {
      chavesEmGravacao.current.set(String(id), ordemAnterior ? String(ordemAnterior) : '')
      setAtividades(lista => lista.map(item => (
        mesmoId(item.atividade_id, id)
          ? { ...item, atividadeStatus_id: statusAnterior, atividade_ord: ordemAnterior }
          : item
      )))
      if (form && mesmoId(form.atividade_id, id)) {
        setForm(valor => (valor ? { ...valor, atividadeStatus_id: String(statusAnterior) } : valor))
        setBase(valor => (valor ? { ...valor, atividadeStatus_id: String(statusAnterior) } : valor))
      }
      notifyError('Não foi possível atualizar a atividade.')
    }
  }

  function soltar(event, statusId) {
    event.preventDefault()
    const id = event.dataTransfer.getData('text/plain')
    mover(id, statusId, null, 'depois')
  }

  function soltarNoCartao(event, alvo, posicao) {
    const id = event.dataTransfer.getData('text/plain')
    mover(id, alvo.atividadeStatus_id, alvo, posicao)
  }

  async function adicionarTarefa(atividadeId, nome) {
    const id = await insert('todo', {
      todo_nome: nome,
      todo_concluida: 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(atividadeId),
      todo_ativo: 1,
    })
    if (!id) {
      notifyError('Não foi possível adicionar a tarefa.')
      return false
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(listaTodo || [])
    return true
  }

  async function concluirTarefa(tarefa) {
    const marcando = !Number(tarefa.todo_concluida)
    const id = await update('todo', tarefa.todo_id, {
      todo_nome: tarefa.todo_nome,
      todo_concluida: marcando ? 1 : 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(tarefa.todo_tabId),
      todo_ativo: 1,
    })
    if (!id) {
      notifyError('Não foi possível atualizar a tarefa.')
      return
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    const atualizados = listaTodo || []
    setTodos(atualizados)
    if (!marcando) return
    const daAtividade = atualizados.filter(item => (
      mesmoId(item.todo_tabId, tarefa.todo_tabId) && item.todo_tabRef === 'atividade'
    ))
    const atividade = atividades.find(item => mesmoId(item.atividade_id, tarefa.todo_tabId))
    if (!atividade || !daAtividade.length) return
    const todas = daAtividade.every(item => Number(item.todo_concluida))
    if (todas && !mesmoId(atividade.atividadeStatus_id, STATUS_CONCLUIDO)) {
      const destino = colunas.find(coluna => mesmoId(coluna.id, STATUS_CONCLUIDO))
      if (destino && destino.id != null) {
        setPergunta({
          texto: `Passar atividade para ${destino.nome}?`,
          aoConfirmar: () => mover(atividade.atividade_id, destino.id, null, 'depois'),
        })
      }
      return
    }
    if (mesmoId(atividade.atividadeStatus_id, STATUS_NAO_INICIADO)) {
      const destino = colunas.find(coluna => mesmoId(coluna.id, STATUS_EM_ANDAMENTO))
      if (destino && destino.id != null) {
        setPergunta({
          texto: `Passar atividade para ${destino.nome}?`,
          aoConfirmar: () => mover(atividade.atividade_id, destino.id, null, 'depois'),
        })
      }
    }
  }

  async function renomearTarefa(tarefa, nome) {
    const id = await update('todo', tarefa.todo_id, {
      todo_nome: nome,
      todo_concluida: Number(tarefa.todo_concluida) ? 1 : 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(tarefa.todo_tabId),
      todo_ativo: 1,
    })
    if (!id) {
      notifyError('Não foi possível atualizar a tarefa.')
      return false
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(listaTodo || [])
    return true
  }

  async function excluirTarefa(tarefa) {
    const id = await update('todo', tarefa.todo_id, {
      todo_nome: tarefa.todo_nome,
      todo_concluida: Number(tarefa.todo_concluida) ? 1 : 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(tarefa.todo_tabId),
      todo_ativo: 0,
    })
    if (!id) {
      notifyError('Não foi possível excluir a tarefa.')
      return
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(listaTodo || [])
  }

  useEffect(() => {
    function tecla(event) {
      if (event.key === 'Escape') fechar()
    }
    document.addEventListener('keydown', tecla)
    return () => document.removeEventListener('keydown', tecla)
  })

  const projetosAndamento = projetos.filter(projeto => (
    situacaoProjAndamentoId != null && mesmoId(projeto.projSituacao_id, situacaoProjAndamentoId)
  ))

  function opcoesProjeto() {
    if (!form) return []
    let lista = form.pf_id
      ? projetosAndamento.filter(projeto => naEquipe(form.pf_id, projeto.proj_id))
      : [...projetosAndamento]
    if (form.proj_id && !lista.some(projeto => mesmoId(projeto.proj_id, form.proj_id))) {
      const atual = projetos.find(projeto => mesmoId(projeto.proj_id, form.proj_id))
      if (atual) lista = [...lista, atual]
    }
    return [...lista].sort((a, b) => String(a.proj_nome).localeCompare(String(b.proj_nome), 'pt-BR'))
  }

  function opcoesProduto() {
    if (!form) return []
    const idsAndamento = new Set(projetosAndamento.map(projeto => String(projeto.proj_id)))
    let lista = produtos.filter(produto => idsAndamento.has(String(produto.proj_id)))
    if (form.proj_id) {
      lista = produtos.filter(produto => (
        mesmoId(produto.proj_id, form.proj_id)
        && (idsAndamento.has(String(produto.proj_id)) || mesmoId(produto.prod_id, form.prod_id))
      ))
    } else if (form.pf_id) {
      const projetosDaPessoa = new Set(
        equipe.filter(linha => mesmoId(linha.pf_id, form.pf_id)).map(linha => String(linha.proj_id)),
      )
      lista = lista.filter(produto => projetosDaPessoa.has(String(produto.proj_id)))
    }
    if (form.prod_id && !lista.some(produto => mesmoId(produto.prod_id, form.prod_id))) {
      const atual = produtos.find(produto => mesmoId(produto.prod_id, form.prod_id))
      if (atual) lista = [...lista, atual]
    }
    return [...lista].sort((a, b) => String(a.prod_desc).localeCompare(String(b.prod_desc), 'pt-BR'))
  }

  function opcoesPessoa() {
    if (!form) return []
    let lista = form.proj_id
      ? pessoas.filter(pessoa => naEquipe(pessoa.pf_id, form.proj_id))
      : [...pessoas]
    if (form.pf_id && !lista.some(pessoa => mesmoId(pessoa.pf_id, form.pf_id))) {
      const atual = pessoas.find(pessoa => mesmoId(pessoa.pf_id, form.pf_id))
        || { pf_id: form.pf_id, pf_nomeExibicao: 'Você' }
      lista = [...lista, atual]
    }
    return [...lista].sort((a, b) => nomePessoa(a).localeCompare(nomePessoa(b), 'pt-BR'))
  }

  function adicionarDoPainel(nome) {
    if (!form || !form.atividade_id) return false
    return adicionarTarefa(form.atividade_id, nome)
  }

  function locaisDoForm() {
    if (form && form.atividade_local && !LOCAIS.includes(form.atividade_local)) {
      return [...LOCAIS, form.atividade_local]
    }
    return LOCAIS
  }

  if (semPermissao) {
    return (
      <div className="gestao-page">
        <p className="gestao-erro">Você não tem permissão para acessar essa tela</p>
      </div>
    )
  }

  /* eslint-disable react/jsx-no-bind */
  function renderCartao(item, compacto, tresLinhas) {
    const posicao = marca && marca.id === String(item.atividade_id) ? marca.posicao : ''
    const produto = produtoPorId.get(String(item.prod_id))
    const projId = item.proj_id || (produto ? produto.proj_id : '')
    const projetosCard = (() => {
      let lista = item.pf_id
        ? projetosAndamento.filter(projeto => naEquipe(item.pf_id, projeto.proj_id))
        : [...projetosAndamento]
      if (projId && !lista.some(projeto => mesmoId(projeto.proj_id, projId))) {
        const atual = projetoPorId.get(String(projId))
        if (atual) lista = [...lista, atual]
      }
      return [...lista].sort((a, b) => String(a.proj_nome).localeCompare(String(b.proj_nome), 'pt-BR'))
    })()
    const produtosCard = (() => {
      const idsAndamento = new Set(projetosAndamento.map(projeto => String(projeto.proj_id)))
      let lista = produtos.filter(opcao => idsAndamento.has(String(opcao.proj_id)))
      if (projId) lista = lista.filter(opcao => mesmoId(opcao.proj_id, projId))
      if (item.prod_id && !lista.some(opcao => mesmoId(opcao.prod_id, item.prod_id))) {
        if (produto) lista = [...lista, produto]
      }
      return [...lista].sort((a, b) => String(a.prod_desc).localeCompare(String(b.prod_desc), 'pt-BR'))
    })()
    const pessoasCard = (() => {
      let lista = projId
        ? pessoas.filter(pessoa => naEquipe(pessoa.pf_id, projId))
        : [...pessoas]
      if (item.pf_id && !lista.some(pessoa => mesmoId(pessoa.pf_id, item.pf_id))) {
        const atual = pessoas.find(pessoa => mesmoId(pessoa.pf_id, item.pf_id))
        if (atual) lista = [...lista, atual]
      }
      return [...lista].sort((a, b) => nomePessoa(a).localeCompare(nomePessoa(b), 'pt-BR'))
    })()
    const natureza = setorAtivLista.find(opcao => mesmoId(opcao.setorAtiv_id, item.setorAtiv_id))
    const qtd = rotuloQuantidade(item.unidade_id, item.atividade_unidadeQtd)
    const unidade = unidades.find(opcao => mesmoId(opcao.unidade_id, item.unidade_id))
    return (
      <Cartao
        key={item.atividade_id}
        item={item}
        pessoa={pessoaDe(item.pf_id)}
        produto={produto}
        natureza={natureza ? natureza.setorAtiv_nome : ''}
        unidade={qtd || (unidade ? unidade.unidade_nome : '')}
        tarefas={tarefasDe(item.atividade_id)}
        aberta={Boolean(form && mesmoId(form.atividade_id, item.atividade_id))}
        compacto={Boolean(compacto)}
        tresLinhas={Boolean(tresLinhas)}
        marca={posicao}
        projetosCard={projetosCard}
        produtosCard={produtosCard}
        pessoasCard={pessoasCard}
        onAbrir={abrir}
        onGravar={gravarCampos}
        onMarcarHoje={marcarHoje}
        onExcluirAtividade={excluirAtividade}
        onAdicionarTarefa={adicionarTarefa}
        onConcluirTarefa={concluirTarefa}
        onRenomearTarefa={renomearTarefa}
        onExcluirTarefa={excluirTarefa}
        onSobre={valor => marcarCartao(item, valor)}
        onSoltar={(event, valor) => soltarNoCartao(event, item, valor)}
        onFimArraste={limparMarca}
      />
    )
  }
  return (
    <div className="gestao-page">
      <header className="gestao-top">
        <div className="gestao-topo-linha">
          <div>
            <h1>Gestão de atividades</h1>
            <p>
              {veTudo
                ? 'Atividades de todos os colaboradores e o status de cada uma.'
                : 'Atividades atribuídas a você e o status de cada uma.'}
            </p>
          </div>
          <button
            type="button"
            className="gestao-btn gestao-btn-primario"
            onClick={() => setModalPonto(true)}
          >
            Registrar atividades
          </button>
        </div>
        <form className="gestao-filtros" onSubmit={event => event.preventDefault()}>
          <label className="gestao-campo" htmlFor="gestao-busca">
            Nome da atividade
            <input id="gestao-busca" value={busca} onChange={event => setBusca(event.target.value)} />
          </label>
          {veTudo && (
            <label className="gestao-campo" htmlFor="gestao-filtro-pf">
              Responsável
              <select id="gestao-filtro-pf" value={filtroPf} onChange={event => setFiltroPf(event.target.value)}>
                <option value="">Todos</option>
                {[...pessoas].sort((a, b) => nomePessoa(a).localeCompare(nomePessoa(b), 'pt-BR')).map(pessoa => (
                  <option key={pessoa.pf_id} value={pessoa.pf_id}>{nomePessoa(pessoa)}</option>
                ))}
              </select>
            </label>
          )}
          <label className="gestao-campo" htmlFor="gestao-filtro-mes">
            Mês de referência
            <select id="gestao-filtro-mes" value={filtroMes} onChange={event => setFiltroMes(event.target.value)}>
              <option value="">Todos</option>
              {meses.map(chave => (
                <option key={chave} value={chave}>{rotuloMes(chave)}</option>
              ))}
            </select>
          </label>
          <label className="gestao-campo" htmlFor="gestao-filtro-tipo">
            Natureza da atividade
            <select id="gestao-filtro-tipo" value={filtroTipo} onChange={event => setFiltroTipo(event.target.value)}>
              <option value="">Todas</option>
              {naturezasFiltro.map(item => (
                <option key={item.setorAtiv_id} value={item.setorAtiv_id}>{item.setorAtiv_nome}</option>
              ))}
            </select>
          </label>
          <label className="gestao-campo gestao-filtro-hoje" htmlFor="gestao-filtro-hoje">
            Atividades do dia
            <input
              id="gestao-filtro-hoje"
              type="checkbox"
              checked={filtroHoje}
              onChange={event => setFiltroHoje(event.target.checked)}
            />
          </label>
          <label className="gestao-campo gestao-filtro-hoje" htmlFor="gestao-filtro-minhas">
            Minhas atividades
            <input
              id="gestao-filtro-minhas"
              type="checkbox"
              checked={filtroMinhas}
              onChange={event => setFiltroMinhas(event.target.checked)}
            />
          </label>
        </form>
      </header>

      {carregando && (
        <div className="gestao-estado" role="status">
          <span className="gestao-spinner" />
          As atividades estão sendo buscadas.
        </div>
      )}
      {erro && <p className="gestao-erro">{erro}</p>}

      {!carregando && !erro && (
        <>
          <div
            className="gestao-board"
            style={{
              gridTemplateColumns: faixasQuadro(colunas, recolhidas),
            }}
          >
            {colunas.map(coluna => {
              const chaveColuna = String(coluna.id)
              const itens = ordenarPorChave(visiveis.filter(item => mesmoId(item.atividadeStatus_id, coluna.id)))
              const discreta = Boolean(coluna.podeRecolher && recolhidas[chaveColuna])
              return (
                <section
                  key={chaveColuna}
                  className={`gestao-coluna${discreta ? ' is-discreta' : ''}${sobre === chaveColuna ? ' is-sobre' : ''}`}
                  onDragOver={event => {
                    event.preventDefault()
                    event.dataTransfer.dropEffect = 'move'
                    setSobre(chaveColuna)
                  }}
                  onDragLeave={event => {
                    if (!event.currentTarget.contains(event.relatedTarget)) limparMarca()
                  }}
                  onDrop={event => soltar(event, coluna.id)}
                >
                  <header className="gestao-coluna-head">
                    <div className="gestao-coluna-topo">
                      <h2>{coluna.nome}</h2>
                      <span className="gestao-coluna-acoes">
                        {coluna.podeRecolher && (
                          <button
                            type="button"
                            className="gestao-btn-icone"
                            aria-pressed={discreta}
                            aria-label={discreta ? 'Mostrar mais detalhes' : 'Mostrar menos detalhes'}
                            title={discreta ? 'Mais detalhes' : 'Menos detalhes'}
                            onClick={() => setRecolhidas(atual => ({ ...atual, [chaveColuna]: !atual[chaveColuna] }))}
                          >
                            <img
                              src={iconeMiv(discreta ? 'maximize-01' : 'minimize-01')}
                              alt=""
                              width="16"
                              height="16"
                            />
                          </button>
                        )}
                        {coluna.podeCriar && (
                          <button
                            type="button"
                            className="gestao-btn gestao-btn-primario gestao-mais"
                            disabled={criando}
                            aria-label={`Incluir atividade em ${coluna.nome}`}
                            onClick={() => criarNaColuna(coluna.id)}
                          >
                            +
                          </button>
                        )}
                        <span className="gestao-contagem">{itens.length}</span>
                      </span>
                    </div>
                  </header>
                  <div className="gestao-lista">
                    {!itens.length && <p className="gestao-vazio">Nenhuma atividade</p>}
                    {itens.map(item => renderCartao(item, discreta, todasExpandidas))}
                  </div>
                </section>
              )
            })}
          </div>
          {fora.length > 0 && (
            <section className="gestao-fora">
              <h2>{fora.length} fora do quadro</h2>
              <div className="gestao-fora-lista">
                {ordenarPorChave(fora).map(item => renderCartao(item, false, todasExpandidas))}
              </div>
            </section>
          )}
        </>
      )}

      {form && (
        <>
          <div className="gestao-fundo" onClick={fechar} />
          <aside className="gestao-lateral" role="dialog" aria-modal="true" aria-labelledby="gestao-lateral-titulo">
            <header className="gestao-lateral-head">
              <h2 id="gestao-lateral-titulo">{form.atividade_id ? 'Editar atividade' : 'Nova atividade'}</h2>
              <button type="button" className="gestao-fechar" onClick={fechar} aria-label="Fechar">×</button>
            </header>
            <form className="gestao-form" onSubmit={salvar}>
              <label className="gestao-campo" htmlFor="gestao-nome">
                Nome da atividade
                <input
                  id="gestao-nome"
                  value={form.atividade_nome}
                  onChange={event => setForm(prev => ({ ...prev, atividade_nome: event.target.value }))}
                />
              </label>
              <label className="gestao-campo" htmlFor="gestao-projeto">
                Projeto
                <select id="gestao-projeto" value={form.proj_id} onChange={event => escolherProjeto(event.target.value)}>
                  <option value="">Sem projeto</option>
                  {opcoesProjeto().map(projeto => (
                    <option key={projeto.proj_id} value={projeto.proj_id}>{projeto.proj_nome}</option>
                  ))}
                </select>
              </label>
              <label className="gestao-campo" htmlFor="gestao-produto">
                Produto
                <select id="gestao-produto" value={form.prod_id} onChange={event => escolherProduto(event.target.value)}>
                  <option value="">Sem produto</option>
                  {opcoesProduto().map(produto => (
                    <option key={produto.prod_id} value={produto.prod_id}>{produto.prod_desc}</option>
                  ))}
                </select>
              </label>
              <label className="gestao-campo" htmlFor="gestao-responsavel">
                Responsável
                <select
                  id="gestao-responsavel"
                  value={form.pf_id}
                  disabled={!veTudo}
                  onChange={event => setForm(prev => ({ ...prev, pf_id: event.target.value }))}
                >
                  <option value="">Sem responsável</option>
                  {opcoesPessoa().map(pessoa => (
                    <option key={pessoa.pf_id} value={pessoa.pf_id}>{nomePessoa(pessoa)}</option>
                  ))}
                </select>
              </label>
              <label className="gestao-campo" htmlFor="gestao-tipo">
                Natureza da atividade
                <select
                  id="gestao-tipo"
                  value={form.setorAtiv_id}
                  onChange={event => setForm(prev => ({ ...prev, setorAtiv_id: event.target.value }))}
                >
                  <option value="">Selecione</option>
                  {naturezasForm.map(natureza => (
                    <option key={natureza.setorAtiv_id} value={natureza.setorAtiv_id}>{natureza.setorAtiv_nome}</option>
                  ))}
                </select>
              </label>
              <label className="gestao-campo" htmlFor="gestao-ini-plan">
                Início previsto
                <input
                  id="gestao-ini-plan"
                  type="date"
                  value={form.atividade_dtIniPlanejada}
                  onChange={event => setForm(prev => ({ ...prev, atividade_dtIniPlanejada: event.target.value }))}
                />
              </label>
              <label className="gestao-campo" htmlFor="gestao-dias">
                Dias p/ execução
                <input
                  id="gestao-dias"
                  type="number"
                  min="0"
                  step="1"
                  value={form.atividade_prazoDiasExecucao}
                  onChange={event => setForm(prev => ({ ...prev, atividade_prazoDiasExecucao: event.target.value }))}
                />
              </label>
              <div className="gestao-campo">
                Data prevista para conclusão
                <span className="gestao-conclusao-lida">
                  {formatarIso(somarDias(form.atividade_dtIniPlanejada, form.atividade_prazoDiasExecucao)) || '—'}
                </span>
              </div>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="gestao-campo" htmlFor="gestao-tempo">
                Tempo previsto
                <MaskedInput
                  id="gestao-tempo"
                  mask="00:00"
                  lazy={false}
                  placeholder="HH:mm"
                  value={form.atividade_tempoEstimado || ''}
                  onAccept={valor => setForm(prev => ({ ...prev, atividade_tempoEstimado: String(valor || '') }))}
                />
              </label>
              <label className="gestao-campo" htmlFor="gestao-local">
                Local
                <select
                  id="gestao-local"
                  value={form.atividade_local}
                  onChange={event => setForm(prev => ({ ...prev, atividade_local: event.target.value }))}
                >
                  <option value="">Selecione</option>
                  {locaisDoForm().map(local => (
                    <option key={local} value={local}>{local}</option>
                  ))}
                </select>
              </label>
              <label className="gestao-campo" htmlFor="gestao-coment">
                Comentário
                <textarea
                  id="gestao-coment"
                  value={form.atividade_coment}
                  onChange={event => setForm(prev => ({ ...prev, atividade_coment: event.target.value }))}
                />
              </label>
              <div className="gestao-acoes">
                <button type="submit" className="gestao-btn gestao-btn-primario" disabled={salvando}>
                  {salvando ? 'Salvando...' : 'Salvar'}
                </button>
                <button type="button" className="gestao-btn gestao-btn-secundario" onClick={fechar} disabled={salvando}>
                  Cancelar
                </button>
              </div>
            </form>
            {form.atividade_id && (
              <ListaTarefas
                tarefas={tarefasDe(form.atividade_id)}
                onAdicionar={adicionarDoPainel}
                onConcluir={concluirTarefa}
                onRenomear={renomearTarefa}
                onExcluir={excluirTarefa}
              />
            )}
          </aside>
        </>
      )}
      {modalPonto && (
        <div className="ativ-modal-fundo">
          <div className="ativ-modal gestao-modal-ponto" role="dialog" aria-modal="true" aria-label="Registrar atividades">
            <div className="ativ-modal-head">
              <button type="button" className="ativ-fechar" aria-label="Fechar" onClick={() => setModalPonto(false)}>
                ×
              </button>
            </div>
            <RegistrarPonto
              embutido
              onRegistrado={() => setVersao(atual => atual + 1)}
            />
          </div>
        </div>
      )}
      {concluirHoras && (
        <div className="ativ-modal-fundo">
          <div className="ativ-modal gestao-pergunta" role="dialog" aria-modal="true" aria-labelledby="gestao-concluir-horas-titulo">
            <h2 id="gestao-concluir-horas-titulo">
              {concluirHoras.obrigatorio
                ? 'Registre as horas desta atividade para concluí-la.'
                : 'Informe o tempo realizado desta atividade.'}
            </h2>
            <p className="gestao-concluir-horas-nome">{concluirHoras.item.atividade_nome || 'Sem nome'}</p>
            {concluirHoras.retroativo && (
              <>
                <p className="gestao-concluir-horas-aviso">
                  {concluirHoras.prevista
                    ? `A data prevista para conclusão (${formatarIso(concluirHoras.prevista)}) difere do dia de hoje.`
                    : 'A data prevista para conclusão difere do dia de hoje.'}
                  {' '}
                  Informe a data e a justificativa para registrar as horas retroativamente.
                </p>
                <div className="gestao-concluir-horas-retro">
                  <label className="gestao-campo" htmlFor="gestao-concluir-data">
                    Data
                    <input
                      id="gestao-concluir-data"
                      type="date"
                      max={ontemIso()}
                      value={concluirHoras.data}
                      onChange={evento => {
                        const valor = evento.target.value
                        setConcluirHoras(atual => (atual ? { ...atual, data: valor } : atual))
                      }}
                    />
                  </label>
                  <label className="gestao-campo" htmlFor="gestao-concluir-justif">
                    Justificativa
                    <input
                      id="gestao-concluir-justif"
                      type="text"
                      value={concluirHoras.justificativa}
                      onChange={evento => {
                        const valor = evento.target.value
                        setConcluirHoras(atual => (atual ? { ...atual, justificativa: valor } : atual))
                      }}
                    />
                  </label>
                </div>
              </>
            )}
            <label className="gestao-campo" htmlFor="gestao-concluir-tempo">
              Tempo realizado
              <MaskedInput
                id="gestao-concluir-tempo"
                mask="00:00"
                lazy={false}
                placeholder="HH:mm"
                value={concluirHoras.tempo}
                onAccept={valor => {
                  const texto = String(valor || '')
                  if (texto && texto.length < 5) return
                  setConcluirHoras(atual => (atual ? { ...atual, tempo: texto } : atual))
                }}
              />
            </label>
            <div className="gestao-acoes">
              <button
                type="button"
                className="gestao-btn gestao-btn-primario"
                disabled={concluirHoras.gravando}
                onClick={confirmarHorasConclusao}
              >
                {concluirHoras.gravando ? 'Registrando...' : 'Registrar e concluir'}
              </button>
              <button
                type="button"
                className="gestao-btn gestao-btn-secundario"
                disabled={concluirHoras.gravando}
                onClick={() => setConcluirHoras(null)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      {pergunta && (
        <div className="ativ-modal-fundo">
          <div className="ativ-modal gestao-pergunta" role="dialog" aria-modal="true">
            <h2>{pergunta.texto}</h2>
            <div className="gestao-acoes">
              <button
                type="button"
                className="gestao-btn gestao-btn-primario"
                onClick={() => {
                  const acao = pergunta.aoConfirmar
                  setPergunta(null)
                  acao()
                }}
              >
                Sim
              </button>
              <button
                type="button"
                className="gestao-btn gestao-btn-secundario"
                onClick={() => {
                  const negar = pergunta.aoNegar
                  setPergunta(null)
                  if (typeof negar === 'function') negar()
                }}
              >
                Não
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
/* eslint-enable react/jsx-no-bind */
